import { render, staticRenderFns } from "./fichafinanceira.vue?vue&type=template&id=434f943f&scoped=true"
import script from "./fichafinanceira.vue?vue&type=script&lang=js"
export * from "./fichafinanceira.vue?vue&type=script&lang=js"
import style0 from "./fichafinanceira.vue?vue&type=style&index=0&id=434f943f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434f943f",
  null
  
)

export default component.exports